import { BrowserRouter } from 'react-router-dom';
import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Toaster } from 'sonner';
import { store, persistor } from '@/store';
import { Spinner } from '@/components/ui';
import AppInitializer from './AppInitializer';
import AppRoutes from './routes';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<Spinner size="xl" fullScreen />} persistor={persistor}>
        <BrowserRouter>
          <AppInitializer />
          <Suspense fallback={<Spinner size="xl" fullScreen />}>
            <AppRoutes />
          </Suspense>
          <Toaster position="top-right" richColors />
          <Analytics />
          <SpeedInsights />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
